import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main/Main';
import ScrollToTop from './MyComponents/ScrollToTop';
import { IntlProvider } from 'react-intl';
import adapter from 'webrtc-adapter';
import { determineDefaultLanguage } from './common/utils';
import managementApi from './Api/managementApi';
import store from './redux/store';
import { updateAppSubscription } from './redux/actions';
import en from './Translations/en.json';
import ro from './Translations/ro.json';
import fr from './Translations/fr.json';

let translationsForUsersLocale = {
    en: en,
    ro: ro,
    fr: fr,
};

class App extends React.Component {
    constructor(props) {
        super(props);
        let currentLanguage = determineDefaultLanguage();
        this.state = { currentLanguage: currentLanguage };
    }

    updateLanguage = (lang) => {
        this.setState({ currentLanguage: lang });
        localStorage.setItem('language', lang);
    };

    componentDidMount() {
        managementApi
            .getSubscriptionTypesForPublic()
            .then((res) => {
                store.dispatch(updateAppSubscription(res.data));
            })
            .catch((err) => {
                console.error('Unable to get the subscriptions', err);
            });
        // window.logEmergency = (msg) => {
        //     let el = document.getElementById('emergencyLogger');
        //     el.innerHTML = el.innerHTML + '<br/>' + msg;
        // };
        // window.logEmergency('ala');
    }

    render() {
        return (
            <IntlProvider
                locale={this.state.currentLanguage}
                messages={translationsForUsersLocale[this.state.currentLanguage]}
            >
                <BrowserRouter>
                    <ScrollToTop />
                    <Main
                        updateLanguage={this.updateLanguage}
                        style={{ 'max-width': '100%' }}
                        language={this.state.currentLanguage}
                    />
                    {/*<div id={'emergencyLogger'} style={{*/}
                    {/*    width: '600px',*/}
                    {/*    height: '400px',*/}
                    {/*    position: 'fixed',*/}
                    {/*    bottom: '0px',*/}
                    {/*    left: '300px',*/}
                    {/*    border: 'solid',*/}
                    {/*    borderColor: 'red',*/}
                    {/*    overflow: 'scroll',*/}
                    {/*}}></div>*/}
                </BrowserRouter>
            </IntlProvider>
        );
    }
}

export default App;
